import {} from '@up/data';
import { IsBoolean, IsDate, IsOptional, IsString } from 'class-validator';

export class StripePaymentMethodDomainResponseDto {
  @IsString()
  domain: string;

  @IsOptional()
  @IsString()
  stripeConnectAccountId?: string;

  @IsBoolean()
  enabled: boolean;

  @IsBoolean()
  liveMode: boolean;

  @IsDate()
  createdDate: Date;

  @IsOptional()
  @IsBoolean()
  applePay?: boolean;

  @IsOptional()
  @IsBoolean()
  googlePay?: boolean;

  @IsOptional()
  @IsBoolean()
  link?: boolean;

  @IsOptional()
  @IsBoolean()
  paypal?: boolean;
}
